import React from "react";
import { createApi } from "../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { NavigateFunction } from "react-router-dom";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";

export const handleDeleteCalendar = (
  calendarID: string,
  setFetchingCalendarData: Dispatcher<boolean>,
  calendarData: any,
  setCalendarData: any,
  setCalendarAlerts: any,
  navigate: NavigateFunction
) => {
  const AxiosUI = createApi(``);

  const retryFunction = () => {
    handleDeleteCalendar(
      calendarID,
      setFetchingCalendarData,
      calendarData,
      setCalendarData,
      setCalendarAlerts,
      navigate
    );
  };

  AxiosUI.delete(`calendar/${calendarID}/`).then(
    (response: AxiosResponse) => {
      setCalendarData(calendarData.filter((obj: any) => obj.id !== calendarID));
      localStorage.setItem("newCalendarName", response.data.name);
      setCalendarAlerts((previousState: any) => {
        return {
          ...previousState,
          deleteCalendarSuccess: true,
          addCalendarSuccess: false,
          setCalendarAlerts: false,
        };
      });
      setFetchingCalendarData(false);
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        alert("Error deleting calendar, please try again");
        setFetchingCalendarData(false);
      });
    }
  );
};
